import React from 'react';
import {
  IResourceComponentsProps,
  BaseRecord,
  CrudFilters,
} from '@refinedev/core';
import {
  useTable,
  List,
  ShowButton,
  DateField,
  EmailField,
  useSelect,
} from '@refinedev/antd';
import {
  Table,
  Space,
  Typography,
  Collapse,
  FormProps,
  Form,
  Input,
  Button,
  Select,
} from 'antd';
import { HyperLinkField } from '../../components/table';
import {
  EARN_USER_HISTORY_STATE_CAMPAIGN_STATUS,
  USERS_LINK,
} from '../../constants';
import { SearchOutlined } from '@ant-design/icons';
const { Panel } = Collapse;

export const EarnUserHistoryList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, searchFormProps } = useTable({
    syncWithLocation: true,
    onSearch: (params: any) => {
      let filters: CrudFilters = [];
      const { search, earnCampaignId, stateCampaign } = params;

      filters = [
        {
          field: 'search',
          operator: 'eq',
          value: search,
        },
        {
          field: 'earnCampaignId',
          operator: 'eq',
          value: earnCampaignId,
        },
        {
          field: 'stateCampaign',
          operator: 'eq',
          value: stateCampaign,
        },
      ];

      return filters;
    },
  });

  return (
    <>
      <Collapse defaultActiveKey={['0']} style={{ marginBottom: 16 }}>
        <Panel header="Filter" key="1">
          <Filter formProps={searchFormProps} />
        </Panel>
      </Collapse>
      <List>
        <Table {...tableProps} rowKey="id">
          <Table.Column dataIndex="id" title="ID" />

          <Table.Column
            dataIndex={['userId']}
            title="User ID"
            render={(value: string) => (
              <HyperLinkField value={value} link={USERS_LINK} />
            )}
          />
          <Table.Column
            dataIndex={['email']}
            title="User Email"
            render={(value: any) => <EmailField value={value} />}
          />
          <Table.Column
            dataIndex="earnCampaignName"
            title="Earn Campaign Name"
          />
          <Table.Column dataIndex="transaction" title="Transaction" />
          <Table.Column dataIndex="platform" title="Platform" />
          <Table.Column
            dataIndex="platformOsVersion"
            title="Platform Os Version"
          />
          <Table.Column dataIndex="stateCampaign" title="State Campaign" />
          <Table.Column
            dataIndex={['stateCampaignAt']}
            title="State Campaign At"
            render={(value: any) => <DateField value={value} />}
          />

          <Table.Column
            dataIndex="actionFlow"
            title="Action Flow"
            render={(value: any) => (
              <Typography.Text code={true} editable={false}>
                {value}
              </Typography.Text>
            )}
          />
          <Table.Column
            title="Actions"
            dataIndex="actions"
            render={(_, record: BaseRecord) => (
              <Space>
                <ShowButton hideText size="small" recordItemId={record.id} />
              </Space>
            )}
          />
        </Table>
      </List>
    </>
  );
};

const Filter: React.FC<{ formProps: FormProps }> = ({ formProps }) => {
  const { selectProps: earnCampaignSelectProps } = useSelect({
    resource: 'earn-campaign',
    optionLabel: 'name',
    pagination: {
      pageSize: 100,
      mode: 'server',
    },
  });
  const earnStateCampaignSelectProps = EARN_USER_HISTORY_STATE_CAMPAIGN_STATUS;
  return (
    <Form layout="vertical" {...formProps}>
      <Form.Item label="Search" name="search">
        <Input
          placeholder="Search user email, user id, transaction"
          prefix={<SearchOutlined />}
        />
      </Form.Item>

      <Form.Item label="Earn Campaign" name="earnCampaignId">
        <Select {...earnCampaignSelectProps} />
      </Form.Item>

      <Form.Item label="State Campaign" name="stateCampaign">
        <Select options={earnStateCampaignSelectProps} />
      </Form.Item>

      <Form.Item>
        <Button htmlType="submit" type="primary">
          Filter
        </Button>
      </Form.Item>
    </Form>
  );
};
